import { IGetAllStatsData } from "../../models/response/IAdminResponse";
import { IStatState } from "../../models/state/IStatState";

 export const initialStatState: IGetAllStatsData = {
    CategoryList: [],
    FilterInfoList: []
      
 };